import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { cleanStatisticsListsByModule, startLoadingGetLastTenLessThan30SearchResultByModule, startLoadingGetTopTenCountSelectedFieldsCompareResultsByModule, startLoadingGetTopTenCountTextSearchInfoByModule, startLoadingGetTopTenQuantityOfFiltersSearchInfoByModule, startLoadingGetTopTenQuantityOfIndicatorsSearchInfoByModule, startLoadingGetTopTenRepetitionsCompareResultByModule, startLoadingGetTopTenRepetitionsSearchResultByModule, startLoadingStatisticsEndUser } from "../../app/actions/statisticActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";
import T1TableTextSearchInfo from "./T1TableTextSearchInfo";
import T2TableIndicatorsSearchInfo from "./T2TableIndicatorsSearchInfo";
import T3TableFiltersSearchInfo from "./T3TableFiltersSearchInfo";
import T4TableRepetitionsSearchResult from "./T4TableRepetitionsSearchResult";
import T5TableLess30SearchResult from "./T5TableLess30SearchResult";
import T6TableSelectedFieldCompareResult from "./T6TableSelectedFieldCompareResult";
import T7TableRepetitionsCompareResult from "./T7TableRepetitionsCompareResult";

const ID_FORM = "reporter-statistic-end-user";
const OPERATION = "list";

const ListStatisticsEndUser = () => {
  debugLogPages(':: ListStatisticsEndUser');
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { catalogModules } =
    useSelector((state) => state.catalogModule);

  const { endUserStatisticList } = useSelector((state) => state.statistic);

  const { endUserStatisticSearchInfoTextModuleList, endUserStatisticSearchInfoIndicatorsModuleList,
    endUserStatisticSearchInfoFiltersModuleList, endUserStatisticSearchResultRepetitionsModuleList,
    endUserStatisticSearchResultLess30ModuleList, endUserStatisticCompareResultFieldsModuleList,
    endUserStatisticCompareResultRepetitionModuleList
  } = useSelector((state) => state.statistic);

  const [moduleSelected, setModuleSelected] = useState("");

  useEffect(() => {
    dispatch(cleanStatisticsListsByModule());
    dispatch(startLoadingStatisticsEndUser());

  }, []);


  const handleChange = (event) => {

    if (event && event != null) {

      setModuleSelected(event);
      dispatch(cleanStatisticsListsByModule());

      dispatch(startLoadingGetTopTenCountTextSearchInfoByModule(event.id));
      dispatch(startLoadingGetTopTenQuantityOfIndicatorsSearchInfoByModule(event.id));
      dispatch(startLoadingGetTopTenQuantityOfFiltersSearchInfoByModule(event.id));
      dispatch(startLoadingGetTopTenRepetitionsSearchResultByModule(event.id));
      dispatch(startLoadingGetLastTenLessThan30SearchResultByModule(event.id));
      dispatch(startLoadingGetTopTenCountSelectedFieldsCompareResultsByModule(event.id));
      dispatch(startLoadingGetTopTenRepetitionsCompareResultByModule(event.id));

    } else {
      setModuleSelected("");
      dispatch(cleanStatisticsListsByModule());
    }
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
      color: state.selectProps.myColor,

    }),

    singleValue: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
      color: "inherit"
    }),
    control: base => ({
      ...base,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: '50px',
      padding: '0 6px'
    }),

    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),

    placeholder: (provided, state) => ({
      ...provided,

    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '50px',

    }),

    clearIndicator: (provided, state) => ({
      ...provided,

      display: 'none'
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,

      color: "inherit"
    }),

  };

  debugLogPages(":: endUserStatisticList", { endUserStatisticList });

  debugLogPages(":: endUserStatisticSearchInfoTextModuleList", { endUserStatisticSearchInfoTextModuleList });
  debugLogPages(":: endUserStatisticSearchInfoIndicatorsModuleList", { endUserStatisticSearchInfoIndicatorsModuleList });
  debugLogPages(":: endUserStatisticSearchInfoFiltersModuleList", { endUserStatisticSearchInfoFiltersModuleList });
  debugLogPages(":: endUserStatisticSearchResultRepetitionsModuleList", { endUserStatisticSearchResultRepetitionsModuleList });
  debugLogPages(":: endUserStatisticSearchResultLess30ModuleList", { endUserStatisticSearchResultLess30ModuleList });
  debugLogPages(":: endUserStatisticCompareResultFieldsModuleList", { endUserStatisticCompareResultFieldsModuleList });
  debugLogPages(":: endUserStatisticCompareResultRepetitionModuleList", { endUserStatisticCompareResultRepetitionModuleList });

  return (
    <>
      <NavbarIconsGenericComponent componentName={"listStatistics"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="container">

        <div className="row">

          {
            endUserStatisticList && endUserStatisticList.length > 0 &&
            endUserStatisticList.map((row, i) => (
              <div className={`row align-items-center`}>
                <div htmlFor={row.class} className="col-md-7 tit-view-view tit-content-view-view">
                  {t(`${ID_FORM}.large.${row.class}`)}:
                </div>
                <div
                  className="col-md-3 txt-view viewContentTxt"
                  name={row.class}
                  id={row.class}
                >{row.value}</div>
              </div>
            ))
          }

        </div>

        <br />
        <hr />
        <br />

        <div className="row">
          <div className="col-md-7" style={{ paddingRight: '0' }}>
            <Select
              styles={customStyles}
              myFontSize="1em"
              myFontWeight="bold"
              onChange={(event) => handleChange(event)}
              classNamePrefix="select-module"
              name="modules"
              inputId="modules"
              value={moduleSelected}
              options={catalogModules}
              //getOptionLabel={(option) => `${option.description}`}
              getOptionLabel={(option) => `${t(`general.component-search-${option.key}`)}`}
              getOptionValue={(option) => `${option.id}`}
              isClearable={true}
              isSearchable={true}
              placeholder="Seleccione un Módulo"
              className="basic-single"
            />
          </div>
        </div>

        <hr />
        <br />

        {/* Lista 1*/}
        {
          moduleSelected && (
            <div className="row">
              {
                <T1TableTextSearchInfo
                  data={endUserStatisticSearchInfoTextModuleList} />
              }
              <hr />
              <br />
            </div>
          )
        }

        {/* Lista 2*/}
        {
          moduleSelected && (
            <div className="row">
              {
                <T2TableIndicatorsSearchInfo
                  data={endUserStatisticSearchInfoIndicatorsModuleList} />
              }
              <hr />
              <br />
            </div>
          )
        }

        {/* Lista 3*/}
        {
          moduleSelected && (
            <div className="row">
              {
                <T3TableFiltersSearchInfo
                  data={endUserStatisticSearchInfoFiltersModuleList} />
              }
              <hr />
              <br />
            </div>
          )
        }

        {/* Lista 4*/}
        {
          moduleSelected && (
            <div className="row">
              {
                <T4TableRepetitionsSearchResult
                  data={endUserStatisticSearchResultRepetitionsModuleList} />
              }
              <hr />
              <br />
            </div>
          )
        }

        {/* Lista 5*/}
        {
          moduleSelected && (
            <div className="row">
              {
                <T5TableLess30SearchResult
                  data={endUserStatisticSearchResultLess30ModuleList} />
              }
              <hr />
              <br />
            </div>
          )
        }

        {/* Lista 6*/}
        {
          moduleSelected && (
            <div className="row">
              {
                <T6TableSelectedFieldCompareResult
                  data={endUserStatisticCompareResultFieldsModuleList} />
              }
              <hr />
              <br />
            </div>
          )
        }

        {/* Lista 7*/}
        {
          moduleSelected && (
            <div className="row">
              {
                <T7TableRepetitionsCompareResult
                  data={endUserStatisticCompareResultRepetitionModuleList} />
              }
            </div>
          )
        }

      </div>

    </>
  );
};

export default ListStatisticsEndUser;
